import { CCol, CContainer, CRow } from "@coreui/react";
import React from "react";
import Banner from "../components/Common/Banner";
import AboutBanner from "../assests/bg-about.png";
import staticData from "../assests/staticData.json";

import ServiceList from "../components/Common/ServiceList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
export default function HighIntensityNursing() {
  const { high_intensity_nursing_service } = staticData;

  return (
    <>
      <Banner
        banner={AboutBanner}
        subtext={"Registered NDIS Provider"}
        text={high_intensity_nursing_service.service_title}
      />
      <section className="services-layout-wrapper">
        <CContainer>
          <CRow>
            <CCol lg={9}>
              <div className="service-detail-wrapper">
                <img
                  src={require(`../assests/${high_intensity_nursing_service.service_image}`)}
                  alt={high_intensity_nursing_service.service_title}
                  className="mb-5 img-fluid w-100 rounded-4"
                  style={{ height: "550px", objectFit: "cover" }}
                />
                <h1>{high_intensity_nursing_service.service_title}</h1>
                {high_intensity_nursing_service.service_desc.map(
                  (desc, index) => (
                    <p key={index} className="themeGrayPara in-fs lh-28">
                      {desc}
                    </p>
                  )
                )}
                {high_intensity_nursing_service.service_desc_list.map(
                  (list, index) => (
                    <div className="service-desc-list-box" key={index}>
                      <div className="service-desc-icon">
                        <span>
                          <FontAwesomeIcon icon={faCheck} />
                        </span>
                      </div>
                      <div>
                        <p
                          key={index}
                          className="themeGrayPara in-fs lh-28 mb-2"
                        >
                          <b style={{ color: "#0b3d2c" }}>{list?.title}</b>:{" "}
                          {list?.title_desc}
                        </p>
                      </div>
                    </div>
                  )
                )}
                {high_intensity_nursing_service.service_desc_bottom.map(
                  (desc, index) => (
                    <p key={index} className="themeGrayPara in-fs lh-28">
                      {desc}
                    </p>
                  )
                )}
              </div>
            </CCol>
            <CCol lg={3}>
              <div className="service-list-wrapper">
                <ServiceList />
              </div>
            </CCol>
          </CRow>
        </CContainer>
      </section>
    </>
  );
}
